let labelUsername = document.querySelector('#loginform .login-username label')
let labelPassword = document.querySelector('#loginform .login-password label')

if(labelUsername){
    document.querySelector('#loginform .login-username input').setAttribute('placeholder', document.querySelector('#loginform .login-username label').textContent)
}

if(labelPassword){
    document.querySelector('#loginform .login-password input').setAttribute('placeholder', document.querySelector('#loginform .login-password label').textContent);
}
